<ng-select
  *ngIf="showSelect"
  class="input-select"
  [readonly]="readOnlySelect"
  [(ngModel)]="value"
  [clearable]="clearable"
  [searchable]="searchable"
  [placeholder]="placeholder"
  [bindValue]="bindValue"
  [bindLabel]="bindLabel"
  [items]="itemsList"
  [typeToSearchText]="searchTerm"
  [multiple]="multiple"
  [markFirst]="false"
  [notFoundText]="'noItemFound'"
  (change)="changeValue($event)"
  (clear)="clearHandler($event)"
  (blur)="blur()"
>
</ng-select>
<div *ngIf="showIcon" class="icon__filter">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M0.875004 1.5C0.875004 1.15482 1.15483 0.875 1.5 0.875H14.8333C15.1785 0.875 15.4583 1.15482 15.4583 1.5C15.4583 1.84518 15.1785 2.125 14.8333 2.125H1.5C1.15483 2.125 0.875004 1.84518 0.875004 1.5Z"
      fill="#161616"
    />
    <path
      d="M1.5 5.875C1.15483 5.875 0.875002 6.15482 0.875 6.5C0.874998 6.84518 1.15482 7.125 1.5 7.125L10.6667 7.12507C11.0118 7.12507 11.2917 6.84525 11.2917 6.50007C11.2917 6.1549 11.0118 5.87507 10.6667 5.87507L1.5 5.875Z"
      fill="#161616"
    />
    <path
      d="M1.5 10.875C1.15483 10.875 0.875004 11.1548 0.875004 11.5C0.875004 11.8452 1.15483 12.125 1.5 12.125H7.33334C7.67852 12.125 7.95834 11.8452 7.95834 11.5C7.95834 11.1548 7.67852 10.875 7.33334 10.875H1.5Z"
      fill="#161616"
    />
    <path
      d="M15.0417 6.5C15.0417 6.15482 14.7618 5.875 14.4167 5.875C14.0715 5.875 13.7917 6.15482 13.7917 6.5V15.2183L13.7866 15.2123C13.6111 15.0051 13.4392 14.7862 13.2784 14.5814L13.2411 14.5339C13.0809 14.33 12.9124 14.1157 12.7815 13.981C12.5409 13.7335 12.1452 13.7279 11.8977 13.9685C11.6502 14.2091 11.6446 14.6048 11.8852 14.8523C11.9591 14.9283 12.0804 15.0798 12.2581 15.306L12.2973 15.356C12.4557 15.5577 12.6415 15.7945 12.833 16.0204C13.0381 16.2625 13.2678 16.514 13.4973 16.7096C13.6124 16.8075 13.742 16.9042 13.8815 16.9788C14.0161 17.0508 14.2014 17.125 14.4167 17.125C14.6319 17.125 14.8173 17.0508 14.9518 16.9788C15.0913 16.9042 15.221 16.8075 15.336 16.7096C15.5656 16.514 15.7952 16.2625 16.0004 16.0204C16.1918 15.7945 16.3776 15.5578 16.536 15.3561L16.5752 15.306C16.7529 15.0798 16.8743 14.9283 16.9482 14.8523C17.1888 14.6048 17.1831 14.2091 16.9356 13.9685C16.6881 13.7279 16.2924 13.7335 16.0518 13.981C15.9209 14.1157 15.7524 14.33 15.5922 14.5339L15.555 14.5814C15.3942 14.7861 15.2223 15.0051 15.0467 15.2123L15.0417 15.2183V6.5Z"
      fill="#161616"
    />
  </svg>
</div>